import { styled } from '@mui/material'
import Link from './Link'

export const MenuLink = styled(Link)({ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', fontWeight: '500' })